import { CardActivity } from './api';

export const CARD_ACTIVITY_EVENT_NAMES = {
  created: '.activity.created',
} as const;

export interface CardActivityCreatedEvent {
  activity: CardActivity;
  board_id: number;
}

// Reflète Card::activities() (orderBy created_at desc), comme commentEvents.ts.
const sortByCreatedAtDesc = (activities: CardActivity[]): CardActivity[] =>
  [...activities].sort((a, b) => (a.created_at < b.created_at ? 1 : a.created_at > b.created_at ? -1 : 0));

export const applyCardActivityCreated = (
  activities: CardActivity[],
  cardId: number,
  event: CardActivityCreatedEvent
): CardActivity[] => {
  if (event.activity.card_id !== cardId) return activities;
  if (activities.some((a) => a.id === event.activity.id)) return activities;
  return sortByCreatedAtDesc([event.activity, ...activities]);
};
